<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="favicon.png" />
      <title>Restó APP</title>
      
    </head>
    <body class="home-page">
    
      <Header :isRestoCompleto=true ></Header>
      <div class="col-lg-12 mx-auto p-3 ">
      
        
        <div class="row" v-if="reservasPendiente==null || reservasPendiente==0">

          <fieldset  v-if="isLogin"  class="border" style="width: 100%;height: 100%;padding-top: 25px;color: white;">
      <h6  class="w-auto">Stock actual de reservas</h6>
     <h3>{{ stock }}</h3>
</fieldset>
          
</div>
        <div class="row" v-if="reservasPendiente!=null && reservasPendiente!=0">
          <div class="col-lg-6 ">
      
          <fieldset  v-if="isLogin"  class="border" style="width: 100%;height: 100%;padding-top: 25px;color: white;">
      <h6  class="w-auto">Stock actual de reservas</h6>
     <h3>{{ stock }}</h3>
</fieldset>

</div>
<div class="col-lg-6 ">
      
      <fieldset  v-if="isLogin"  class="border" style="width: 100%;height: 100%;padding-top: 25px;color: white;">
  <h6  class="w-auto">Reservas pendientes</h6>
 <h3>{{ reservasPendiente }}</h3>
</fieldset>

</div>
   
          </div>
       



    <section>
  <div class="container py-5">

    <!-- FOR DEMO PURPOSE -->
    <header class="text-center mb-5 text-white">
      <div class="row">
        <div class="col-lg-7 mx-auto">
          <h1>Tienda en linea</h1>
          <p>Seleccione el paquete de producto que desea comprar</p>
        </div>
      </div>
    </header>
    <!-- END -->



    <div class="row text-center align-items-end">
      <!-- Pricing Table-->
      <div class="col-lg-4 mb-5 mb-lg-10"  v-for="item in paquetes" :key="item.id">
        <div class="bg-white p-5 rounded-lg shadow">
          <h1 class="h6 text-uppercase font-weight-bold mb-4" style="overflow-wrap: break-word;">{{ item.descripcion }}</h1>
          <h2 class="h1 font-weight-bold">$ {{ new Intl.NumberFormat('es-AR').format(item.precio)  }}<span class="text-small font-weight-normal ml-2"></span></h2>

          <div class="custom-separator my-4 mx-auto bg-primary"></div>

          <ul class="list-unstyled my-5 text-small text-left">
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Contiene un paquete de {{ item.cantidadReservas }} reservas</li>
          </ul>
          <button type="button" v-if="item.precio>0" class="btn btn-lg" style="width: 100%;background-color: #0d6efd; color: white;" @click="irDetalle(item.id, $event)" >Comprar</button>
         <button type="button" v-else class="btn btn-primary  btn-lg" style="width: 100%;" :disabled='isLogin'  @click="goToPage('Register')" > {{ mostrarTextoBoton() }} </button>

        </div>
      </div>
      <!-- END -->


    </div>
  </div>
</section>


        <Footer />
      </div>
    </body>
  </html>
</template>

<script>
import axios from "axios";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
  name: "Tienda",
  components: { Header, Footer  },
  data: function () {
    return {
      restaurante: Object,
      paquetes: [],
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
      stock:null,
      reservasPendiente:null,
      isLogin:false,
    };
  },
  methods: {

    validarPaquetes(){


      if(this.isLogin){

axios
.get("/mp/preferencia-pendiente")
.then(() => {

})
.catch(() => {
this.error = true;
this.error_msg =
  "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
});
}


},

cargarStock(){
  if(this.isLogin){

axios
.get("/getStockReservas")
.then((data) => {
if (data.status == 200) {
 this.stock=data.data.cantidadSinVencer+data.data.cantidadVencer;
 this.reservasPendiente=data.data.cantidadPendiente
}
})
.catch(() => {
this.error = true;
this.error_msg =
  "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
});
}
},
    cargarPaquetes() {
      this.cargarStock()
      
      axios
        .get("/paquetes-tienda")
        .then((data) => {
          if (data.status == 200) {
           this.paquetes=data.data;
           setTimeout(() => {
            this.cargarStock()
           }, 5000);
          }
        })
        .catch(() => {
          this.error = true;
          this.error_msg =
            "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
        });
       

    },
    irDetalle(id, $event) {
      this.$router.push({ name: "detalleCompra",
      params: { id: id}
    });
      $event?.preventDefault();
    },
    goToPage(page, $event) {
      this.$router.push({ name: page});
      $event?.preventDefault();
    },
    mostrarTextoBoton(){
      if(this.isLogin){
        return "Adquirido";
      }else{
        return "Registrarse Gratis";
      }
    
  },
  parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
},
  },
 
  beforeMount() {

    let token=localStorage.token;
if(token!=undefined && token!=null && token!=""){
  let exp=this.parseJwt(token).exp;
  if (Date.now() >= exp * 1000) {
    this.isLogin=false;
}else{
  this.isLogin=true;
}
  
   


  
}

this.validarPaquetes();
    this.cargarPaquetes();
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}
body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
.btn-primary {
  margin: 15px;
}


/*
*
* ==========================================
* CUSTOM UTIL CLASSES
* ==========================================
*
*/

.rounded-lg {
  border-radius: 1rem !important;
}

.text-small {
  font-size: 0.9rem !important;
}

.custom-separator {
  width: 5rem;
  height: 6px;
  border-radius: 1rem;
}

.text-uppercase {
  letter-spacing: 0.2em;
}

/*
*
* ==========================================
* FOR DEMO PURPOSES
* ==========================================
*
*/
.header-generico{
  background-color: white;
}
body {
  background: #00B4DB;
  background: -webkit-linear-gradient(to right, #0083B0, #00B4DB);
  background: linear-gradient(to right, #0083B0, #00B4DB);
  color: #514B64;
  min-height: 100vh;
}

</style>
